export default {
    BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL || 'http://localhost:3000',
    BACKEND_BASE_PATH: process.env.VUE_APP_BACKEND_BASE_PATH || '',
}